export const BRAND_KIT_PATH = 'content-lab/filestack/brand_kit';
